import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";
import moment from "moment";
import { initReactI18next } from "react-i18next";
import BackendChained from "i18next-chained-backend";

let env_mode = process.env.GATSBY_ENVIRONMENT !== "live";

let env_path = env_mode ? "development" : "live";
let addPath_path = env_mode ? "DEV" : "LIVE";
let addPath_path2 = "qa";

var timestamp = Date.now().toString();

const loadPathFunction = (lng, ns) => {
  if (ns.includes("seo")) {
    return `https://metaloop-translation.s3.eu-central-1.amazonaws.com/${env_path}/website/${lng}/seo.json`;
  } else if (ns.includes("default")) {
    return `https://metaloop-translation.s3.eu-central-1.amazonaws.com/${env_path}/pro-form/${lng}/default.json?t=${timestamp}`;
  }
  return null;
};

i18n
  .use(LanguageDetector)
  .use(BackendChained)
  .use(initReactI18next)
  .init({
    debug: false,
    ns: ["seo", "default"],
    defaultNS: "default",
    detection: {
      order: [
        "querystring",
        "cookie",
        "localStorage",
        "navigator",
        "htmlTag",
        "path",
        "subdomain",
      ],
    },
    keySeparator: ">",
    nsSeparator: "|",
    fallbackLng: "en",
    saveMissing: true,
    supportedLngs: ["en", "de", "es"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
      bindI18n: "languageChanged loaded",
      bindStore: "added removed",
    },
    backend: {
      backends: [Backend, Backend],
      backendOptions: [
        {
          loadPath: (lng, ns) => loadPathFunction(lng, ns),
          allowMultiLoading: true,
        },
        {
          loadPath: (lng, ns) => loadPathFunction(lng, ns),
          addPath: `https://${addPath_path2}.scrap24.com/i18nmissingkey_PRF_${addPath_path}`,
          allowMultiLoading: true,
        },
      ],
    },
  });

i18n.on("languageChanged", function (lng) {
  moment.locale(lng);
});

export default i18n;
